import { css } from "@emotion/react";

import { Alert, Link, Text } from "@livechat/design-system-react-components";

import { HelpCenter } from "constants/help-center";

const banner = css`
  margin: 20px 0 0 0;
`;

export const SetupBanner: React.FC = () => (
  <Alert kind="info" data-testid="setup-banner" css={banner}>
    <Text bold>Forward your emails to HelpDesk</Text>
    <Text>
      To manage your emails in HelpDesk, you have to{" "}
      <Link
        href={`${HelpCenter.SET_UP_CUSTOM_DOMAIN_AND_INBOX}#setting-up-the-forwarding-address`}
        target="_blank"
        bold={false}
      >
        set up email forwarding
      </Link>{" "}
      for your email provider. This will only send copies of messages directly to the ticketing system.
    </Text>
  </Alert>
);
